import {gql} from '@apollo/client';

import {config} from 'config/env';

export const GET_USER_ADDRESSES = gql`
  query getUserAddresses($addressType: String) {
    getUserAddresses(addressType: $addressType) {
      id
      address1
      address2
      country
      firstName
      lastName
      mobile
      company
      longitude
      latitude
      user_longitude
      user_latitude
      deliveryInstructions
      ${config.IS_ENABLE_LOCUS_LAT_LONG ? 'locus_latitude' : ''}
      ${config.IS_ENABLE_LOCUS_LAT_LONG ? 'locus_longitude' : ''}
      ${config.IS_EXPRESS_ADDRESS_FILTERING_ENABLED ? 'isEligibleForExpress' : ''}
      subDistrict {
        id
        nameTh
        nameEn
      }
      isDefault
      province {
        id
        nameTh
        nameEn
      }
      district {
        id
        nameTh
        nameEn
      }
      zip
      taxId
      branchId
      email
      metadata {
        zoomLevel
      }
    }
  }
`;

export const WARE_HOUSE_STORE_DATA = `warehouseStoreData { 
  id
  nameTh
  nameEn
  address1
  address2
  address3
  city
  state
  postCode
  latitude
  longitude
  storeCode
  storeConfigurations { pickupAtStoreEnable }
  }
    __typename
`;

export const GET_STORES_BY_ZIPCODE_SUB_DISTRICT = gql`
query GetStoresByZipcodeSubdistrict($zipcode: String!, $subdistrict: String!) {
  queryStores(zipcode: $zipcode, subdistrict: $subdistrict) {
    stores {
      name
      shopId
      storeCode
      defaultStore
      omsStoreCode
      shippingFeeOfferId
      shopifyLocationId
      sameDay
      ${WARE_HOUSE_STORE_DATA}
    }
    subdistrict
    zipcode
  }
}
`;
